import { activateProductMulti } from 'app/src/msw/shopping/api/acrivateProductMulti'
import { activateProduct } from 'app/src/msw/shopping/api/activateProduct'
import { deleteOrder } from 'app/src/msw/shopping/api/deleteOrder'
import { getCredit } from 'app/src/msw/shopping/api/getCredit'
import { getCreditNote } from 'app/src/msw/shopping/api/getCreditNote'
import { getOrder } from 'app/src/msw/shopping/api/getOrder'
import { getOrders } from 'app/src/msw/shopping/api/getOrders'
import { startOrder } from 'app/src/msw/shopping/api/startOrder'

export const shoppingHandlers = [
  activateProductMulti,
  activateProduct,
  deleteOrder,
  getCredit,
  getCreditNote,
  getOrder,
  getOrders,
  startOrder,
]
